import Swal from 'sweetalert2';
import * as moment from 'moment'
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { SessionObject } from 'src/app/avantoeats-util/models/session/SessionObject';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { Subscription } from 'rxjs';
import { AvantoModalControlService } from 'src/app/services/avanto-modalControl.service';
import { AvantoLambdaService } from 'src/app/services/avanto-lambda.service';
import { AvantoAlert } from 'src/app/util/Alerts';
import { SessionCustomerAddress } from '../../../avantoeats-util/models/session/SessionCustomerAddress';
import { goToThirdPartyDeliveryWebsite } from 'src/app/services/avanto-routing.service';
declare var $: any; //Need this to use JQuery

@Component({
  selector: 'app-order-details-modal',
  templateUrl: './order-details-modal.component.html',
  styleUrls: ['./order-details-modal.component.scss']
})
export class OrderDetailsModalComponent implements OnInit, OnDestroy, AfterViewInit  {

  readonly MODAL_ID = "orderDetailsModal";
  readonly DEFAULT_SELECT_TIME_STR = "Select Time";
  readonly NOTE_APT_NUM = "Apartment: #";
  readonly NOTE_BUZ_NUM = "Buzzer: #";

  sessionId: string;
  orderType: string;
  orderDate: string;

  showOverlay: boolean;

  showOrderTypeChange: boolean;
  showOrderTimeChange: boolean;
  showAddressChange: boolean;

  sessionObserver: Subscription;
  modalControlSubscription: Subscription;

  selectTimeBeingShown: boolean;
  selectedDateTimeTxt: string;
  selectedAddress:string;
  selectedSubAddress:string;
  showStreetNumberMsg:boolean;

  availableDays: string[];
  availableHours: string[];
  displayedAvailableHours: string[];
  selectedDayIndex: number;
  selectedTimeIndex: number;
  minimumTimeIndexForToday: number;

  pickupPreparationTime: string;
  deliveryPreparationTime: string;

  componentHasFinishedLoading:boolean;
  needsToOpenModalAfterLoadingIsFinished:boolean;

  addressNoteWasEdited: boolean;
  addressAdditionalNotes: string;
  addrNotesNumberBeforeEdit:string|null;
  apartmentNumber:number;
  apartmentNumberBeforeEdit:number|null;
  buzzerNumber:number;
  buzzerNumberBeforeEdit:number|null;

  //If present, shows a link to a third party delivery system
  thirdPartyDeliveryLink:string;

  constructor(private avantoSession: AvantoSessionService, private avantoModal: AvantoModalControlService, private lambda: AvantoLambdaService) { }

  ngOnInit() {
    this.addressNoteWasEdited = false;

    this.sessionId = null;
    this.orderType = null;
    this.orderDate = null;
    this.thirdPartyDeliveryLink = null;
    this.showOverlay = false;
    this.selectTimeBeingShown = false;

    this.showAddressChange = true;
    this.showOrderTimeChange = true;
    this.showOrderTypeChange = true;

    this.selectedDateTimeTxt = this.DEFAULT_SELECT_TIME_STR;

    this.selectedAddress = "";
    this.selectedSubAddress = "";

    //Sometimes we may request that the modal open before it's HTML div is loaded. To prevent that we use the following variables
    this.componentHasFinishedLoading = false;
    this.needsToOpenModalAfterLoadingIsFinished = false;
    //-------------------------------------------------------

    this.sessionObserver = this.avantoSession.sessionSubject.subscribe(session => {
      if (session != null) {
        this.sessionId = session.sessionId;
        this.orderType = session.orderType;
        this.orderDate = session.orderDate;

        const receivedAddressSplit = session.customerAddress.getAddressStr().split(",");
        this.selectedAddress = receivedAddressSplit[0];
        this.selectedSubAddress = "";
        if(receivedAddressSplit.length>1){
          for(let i=1;i<receivedAddressSplit.length;i++){
            if(i!=1){
              this.selectedSubAddress += "," + receivedAddressSplit[i];
            }else{
              this.selectedSubAddress += receivedAddressSplit[i].substring(1);
            }
          }
        }

        if(this.selectedAddress == null || this.selectedAddress == "" || this.selectedAddress == SessionCustomerAddress.NO_ADDRESS_STR){
          this.showStreetNumberMsg = false;
        }else{
          //Checks if the address contain a number (we are hoping it has the street number)
          //If it doesnt, we will show a field to add it
          if(!/\d/.test(this.selectedAddress)){
            this.showStreetNumberMsg = true;
          }else{
            this.showStreetNumberMsg = false;
          }
        }

        let retrievedNote = "";
        if(session.customerAddress!=null && session.customerAddress.additionalNotes!=null){
          const notesSplit = session.customerAddress.additionalNotes.split(";");
          notesSplit.forEach(s=>{
            if(s.startsWith(this.NOTE_APT_NUM)){
              this.apartmentNumber = parseInt(s.slice(this.NOTE_APT_NUM.length));
            }else if(s.startsWith(this.NOTE_BUZ_NUM)){
              this.buzzerNumber = parseInt(s.slice(this.NOTE_BUZ_NUM.length));
            }else{
              retrievedNote += s
            }
          })
        }
        this.addressAdditionalNotes = retrievedNote==""?null:retrievedNote;

        this.apartmentNumberBeforeEdit = this.apartmentNumber;
        this.buzzerNumberBeforeEdit = this.buzzerNumber;
        this.addrNotesNumberBeforeEdit = this.addressAdditionalNotes;

        if(session.restaurantInformation!=null){
          if(session.restaurantInformation.minTimeForPickup!=null && session.restaurantInformation.minTimeForPickup>0){
            this.pickupPreparationTime = session.restaurantInformation.minTimeForPickup + " min";
          }else{
            this.pickupPreparationTime = null;
          }

          if(session.restaurantInformation.minTimeForDelivery!=null && session.restaurantInformation.minTimeForDelivery>0){
            this.deliveryPreparationTime = session.restaurantInformation.minTimeForDelivery + " min";
          }else{
            this.deliveryPreparationTime = null;
          }



          this.thirdPartyDeliveryLink = null;
          if(session.restaurantInformation.aboutRestaurant!=null && 
            session.restaurantInformation.aboutRestaurant.additionalContent!=null && 
            session.restaurantInformation.aboutRestaurant.additionalContent.thirdPartyDeliveryWebsite!=null){
            this.thirdPartyDeliveryLink = session.restaurantInformation.aboutRestaurant.additionalContent.thirdPartyDeliveryWebsite;
          } 

        }else{
          this.pickupPreparationTime = null;
          this.deliveryPreparationTime = null;
        }

        if (this.orderDate == SessionObject.DELIVERY_TIME_ASAP) {
          this.selectedDateTimeTxt = this.DEFAULT_SELECT_TIME_STR;
        } else {
          this.selectedDateTimeTxt = this.orderDate;
        }
      }
    })

    this.modalControlSubscription = this.avantoModal.openOrderDetailsModalSubject.subscribe(modalDetails => {
      if(modalDetails!=null){
        this.showAddressChange   = modalDetails.showAddressChange;
        this.showOrderTimeChange = modalDetails.showOrderTime;
        this.showOrderTypeChange = modalDetails.showOrderType;
  
        //If we try to open the modal, but the DIV hasnt been loaded yet, we set "needsToOpenModalAfterLoadingIsFinished" to true.
        // After the DOM is loaded, this variable will be checked and, upon seeing it's true, the code will open the modal
        if(this.componentHasFinishedLoading){
          this.openModal();
        }else{
          this.needsToOpenModalAfterLoadingIsFinished = true;
        }
      }
    });
  }

  ngOnDestroy() {
    this.sessionObserver.unsubscribe();
    this.modalControlSubscription.unsubscribe();
  }

  ngAfterViewInit(){
    //If we try to open the modal, but the DIV hasnt been loaded yet, we set "needsToOpenModalAfterLoadingIsFinished" to true.
    // After the DOM is loaded, this variable will be checked and, upon seeing it's true, the code will open the modal
    this.componentHasFinishedLoading = true;
    if(this.needsToOpenModalAfterLoadingIsFinished){
      this.needsToOpenModalAfterLoadingIsFinished = false;
      this.openModal();
    }
  }

  isDelivery() {
    return this.orderType == SessionObject.ORDER_TYPE_DELIVERY;
  }
  isAsap() {
    return this.orderDate == SessionObject.DELIVERY_TIME_ASAP;
  }

  chageOrderType(deliveryClicked) {
    this.showOverlay = true;
    const newOrderType = deliveryClicked ? SessionObject.ORDER_TYPE_DELIVERY : SessionObject.ORDER_TYPE_PICKUP;

    try {
      this.avantoSession.setOrderType(this.sessionId, newOrderType).then(() => {
        this.showOverlay = false;
        AvantoAlert.toast("success","Order type changed!");
      });
    } catch (ex) {
      this.showOverlay = false;
      AvantoAlert.toast("error","Could not change order type");
    }
  }

  selectTimeClicked() {
    this.showOverlay = true;

    this.lambda.getScheduleOrderDates().subscribe((result: any) => {
      const receivedData = JSON.parse(result._body).data;
      const now = moment();
      const minimumSelectableTime = moment(receivedData.from);

      this.availableHours = this.getAvailableHours();
      this.minimumTimeIndexForToday = this.getSelectedHourIndex(minimumSelectableTime);
      this.availableDays = this.getDaysArray(now.clone());
      this.selectedDayIndex = 0;
      this.selectedTimeIndex = null;
      this.refreshAvailableHoursList();

      // Pre-populate if a future time was already selected
      if (this.orderDate !== SessionObject.DELIVERY_TIME_ASAP && this.selectedDateTimeTxt !== this.DEFAULT_SELECT_TIME_STR) {
        const existing = this.getTimestampFromOrderTimeString(this.selectedDateTimeTxt);
        if (existing && existing.isValid()) {
          const dayDiff = existing.clone().startOf('day').diff(now.clone().startOf('day'), 'days');
          if (dayDiff >= 0 && dayDiff < this.availableDays.length) {
            this.selectedDayIndex = dayDiff;
            this.selectedTimeIndex = this.getSelectedHourIndex(existing);
            this.refreshAvailableHoursList(true);
          }
        }
      }

      this.selectTimeBeingShown = true;
      this.showOverlay = false;
    }, (error => {
      this.showOverlay = false;
      AvantoAlert.toast("error", "Something went wrong. Please try again...");
    }));
  }


  
  orderDelivery(){
    goToThirdPartyDeliveryWebsite(this.thirdPartyDeliveryLink);
  }

  cancelDateTime() {
    this.selectTimeBeingShown = false;
  }

  selectASAP() {
    this.changeDeliveryTime(SessionObject.DELIVERY_TIME_ASAP)
  }

  acceptDateTime() {
    const selectedDaySplit = this.availableDays[this.selectedDayIndex].split('-');
    const selectedDayWithoutPrefix = selectedDaySplit.length > 1 ? selectedDaySplit[1].trim() : selectedDaySplit[0].trim();
    const dateStr = selectedDayWithoutPrefix.split(',')[1].trim();
    const timeStr = this.displayedAvailableHours[this.selectedTimeIndex].trim();
    const dateTimeStr = dateStr + ", " + timeStr;

    const timestamp = this.getTimestampFromOrderTimeString(dateTimeStr);
    this.selectedDateTimeTxt = dateTimeStr;
    this.changeDeliveryTime(dateTimeStr, timestamp);
  }

  adjustTimesForNewDate() {
    this.selectedTimeIndex = null;
    this.refreshAvailableHoursList();
  }

  private refreshAvailableHoursList(checkForSelectedTimeIndex?: boolean) {
    if (this.selectedDayIndex === 0) {
      let minTimeIndex = this.minimumTimeIndexForToday;
      if (checkForSelectedTimeIndex) {
        if (this.selectedTimeIndex < this.minimumTimeIndexForToday) {
          minTimeIndex = this.selectedTimeIndex;
          this.selectedTimeIndex = 0;
        } else {
          this.selectedTimeIndex = this.selectedTimeIndex - this.minimumTimeIndexForToday;
        }
      }
      this.displayedAvailableHours = this.availableHours.slice(minTimeIndex);
    } else {
      this.displayedAvailableHours = this.availableHours.slice();
    }
  }

  private getSelectedHourIndex(dateTime: moment.Moment): number {
    const split = dateTime.format("HH,mm").split(",");
    const hour = parseInt(split[0]);
    const min = parseInt(split[1]);
    return (4 * hour) + Math.floor(min / 15);
  }

  private getDaysArray(now: moment.Moment): string[] {
    return [
      "Today - " + now.format("ddd, MMM Do YYYY"),
      "Tomorrow - " + now.add(1, 'day').format("ddd, MMM Do YYYY"),
      now.add(1, 'day').format("ddd, MMM Do YYYY"),
      now.add(1, 'day').format("ddd, MMM Do YYYY"),
      now.add(1, 'day').format("ddd, MMM Do YYYY"),
      now.add(1, 'day').format("ddd, MMM Do YYYY"),
      now.add(1, 'day').format("ddd, MMM Do YYYY"),
    ];
  }

  private getTimestampFromOrderTimeString(orderTimeStr: string): moment.Moment {
    const dateTimeSplit = orderTimeStr.split(",");
    if (dateTimeSplit.length < 2) return null;
    const date = dateTimeSplit[0];
    const timeSplit = dateTimeSplit[1].split("-");
    const startTime = timeSplit[0];
    return moment(date + " " + startTime, "MMM Do YYYY hh:mm a");
  }

  private getAvailableHours(): string[] {
    return [
      "12:00 am - 12:15 am", "12:15 am - 12:30 am", "12:30 am - 12:45 am", "12:45 am - 01:00 am",
      "01:00 am - 01:15 am", "01:15 am - 01:30 am", "01:30 am - 01:45 am", "01:45 am - 02:00 am",
      "02:00 am - 02:15 am", "02:15 am - 02:30 am", "02:30 am - 02:45 am", "02:45 am - 03:00 am",
      "03:00 am - 03:15 am", "03:15 am - 03:30 am", "03:30 am - 03:45 am", "03:45 am - 04:00 am",
      "04:00 am - 04:15 am", "04:15 am - 04:30 am", "04:30 am - 04:45 am", "04:45 am - 05:00 am",
      "05:00 am - 05:15 am", "05:15 am - 05:30 am", "05:30 am - 05:45 am", "05:45 am - 06:00 am",
      "06:00 am - 06:15 am", "06:15 am - 06:30 am", "06:30 am - 06:45 am", "06:45 am - 07:00 am",
      "07:00 am - 07:15 am", "07:15 am - 07:30 am", "07:30 am - 07:45 am", "07:45 am - 08:00 am",
      "08:00 am - 08:15 am", "08:15 am - 08:30 am", "08:30 am - 08:45 am", "08:45 am - 09:00 am",
      "09:00 am - 09:15 am", "09:15 am - 09:30 am", "09:30 am - 09:45 am", "09:45 am - 10:00 am",
      "10:00 am - 10:15 am", "10:15 am - 10:30 am", "10:30 am - 10:45 am", "10:45 am - 11:00 am",
      "11:00 am - 11:15 am", "11:15 am - 11:30 am", "11:30 am - 11:45 am", "11:45 am - 12:00 pm",
      "12:00 pm - 12:15 pm", "12:15 pm - 12:30 pm", "12:30 pm - 12:45 pm", "12:45 pm - 01:00 pm",
      "01:00 pm - 01:15 pm", "01:15 pm - 01:30 pm", "01:30 pm - 01:45 pm", "01:45 pm - 02:00 pm",
      "02:00 pm - 02:15 pm", "02:15 pm - 02:30 pm", "02:30 pm - 02:45 pm", "02:45 pm - 03:00 pm",
      "03:00 pm - 03:15 pm", "03:15 pm - 03:30 pm", "03:30 pm - 03:45 pm", "03:45 pm - 04:00 pm",
      "04:00 pm - 04:15 pm", "04:15 pm - 04:30 pm", "04:30 pm - 04:45 pm", "04:45 pm - 05:00 pm",
      "05:00 pm - 05:15 pm", "05:15 pm - 05:30 pm", "05:30 pm - 05:45 pm", "05:45 pm - 06:00 pm",
      "06:00 pm - 06:15 pm", "06:15 pm - 06:30 pm", "06:30 pm - 06:45 pm", "06:45 pm - 07:00 pm",
      "07:00 pm - 07:15 pm", "07:15 pm - 07:30 pm", "07:30 pm - 07:45 pm", "07:45 pm - 08:00 pm",
      "08:00 pm - 08:15 pm", "08:15 pm - 08:30 pm", "08:30 pm - 08:45 pm", "08:45 pm - 09:00 pm",
      "09:00 pm - 09:15 pm", "09:15 pm - 09:30 pm", "09:30 pm - 09:45 pm", "09:45 pm - 10:00 pm",
      "10:00 pm - 10:15 pm", "10:15 pm - 10:30 pm", "10:30 pm - 10:45 pm", "10:45 pm - 11:00 pm",
      "11:00 pm - 11:15 pm", "11:15 pm - 11:30 pm", "11:30 pm - 11:45 pm", "11:45 pm - 11:59 pm",
    ];
  }

  /**
   * Saves the selected order time on the session
   * @param newDateTime String containing the date time in readable format (either 'ASAP' or a date like '10th december 2019, 22:30')
   * @param futureDateTimestamp timestamp with the date the order should be placed
   */
  private changeDeliveryTime(newDateTime, futureDateTimestamp?) {
    this.showOverlay = true;
    try {
      this.avantoSession.setOrderTime(this.sessionId, newDateTime, futureDateTimestamp).then(() => {
        this.showOverlay = false;
        this.selectTimeBeingShown = false;
        AvantoAlert.toast("success",'Order time changed!');
      });
    } catch (ex) {
      this.showOverlay = false;
      AvantoAlert.toast("error",'Could not change order time');
    }
  }

  locationChosen() {
    AvantoAlert.toast("success",'Location changed!');
  }

  addressEdited() {
    this.addressNoteWasEdited = true;
  }
  /** whenever the user changes their order details (delivery time, type or address), we call this method to validate the changes with the selected restaurant */
  editAddAddressNote() {

    let editedNote = "";

    if(this.apartmentNumber!=null){
      editedNote += this.NOTE_APT_NUM+this.apartmentNumber+";"
    }

    if(this.buzzerNumber!=null){
      editedNote += this.NOTE_BUZ_NUM+this.buzzerNumber+";"
    }

    if(this.addressAdditionalNotes!=null){
      editedNote += this.addressAdditionalNotes;
    }

    if(editedNote==""){
      editedNote = null;
    }
    
    this.showOverlay = true;
    this.avantoSession.editAddressNote(editedNote)
      .then(() => { 
        AvantoAlert.toast("success","Address instructions updated")
      })
      .catch(() => {
        Swal.fire("Could not save the address note", "Please, try again", "error")
      }).finally(()=>{
        this.addressNoteWasEdited = false;
        this.showOverlay = false;
      })
  }


  cancelAddressNoteChange(){
    this.apartmentNumber = this.apartmentNumberBeforeEdit;
    this.buzzerNumber = this.buzzerNumberBeforeEdit;
    this.addressAdditionalNotes = this.addrNotesNumberBeforeEdit;
    this.addressNoteWasEdited = false;
  }

  openModal() {
    $("#" + this.MODAL_ID).modal();
  }
}
